import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useProducts } from '@/hooks/useProducts';
import { OutletForm } from '@/components/outlets/OutletForm';
import type { CreateOutletRequest } from '@photobooth/types';

export function NewOutletPage() {
  const navigate = useNavigate();
  const { products } = useProducts();

  const handleCreate = async (data: CreateOutletRequest) => {
    const response = await api.outlets.create(data);
    if (response.success && response.data) {
      navigate(`/outlets/${response.data.outletId}`);
    }
  };

  return (
    <div className="p-8">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate('/outlets')}
          className="text-primary hover:underline mb-4"
        >
          ← Back to Outlets
        </button>

        <div className="bg-surface rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold text-text mb-6">Create New Outlet</h1>
          <OutletForm
            products={products}
            onSubmit={handleCreate}
            onCancel={() => navigate('/outlets')}
          />
        </div>
      </div>
    </div>
  );
}
